export default [
  {
    name: 'creation-id',
    path: 'teacher/:teacherId/creations/:id',
    component: () => import(/* webpackChunkName: "creation-id" */ '@/views/Creation'),
    meta: {
      keepAlive: false
    }
  }
]
